import { removeFromArray } from "../../utils/utils";

const medias = "media";
const mediasOrder = "mediaOrder";
const today = new Date();

export const newMedia = (media) => {
  const added = "MEDIA_ADDED";
  const adding = "MEDIA_ADDING";
  const ERROR = "MEDIA_ADD_ERROR";
  const clearStatus = "MEDIA_ADD_CLEAR_STATUS";
  return (dispatch, not, { getFirebase, getFirestore }) => {
    let categoryData;
    const firestore = getFirestore();
    const firebase = getFirebase();
    const batch = firestore.batch();

    const currentTime = firebase.firestore.Timestamp.fromDate(today);
    const mediaRef = firestore.collection(medias).doc(media.id);
    const mediaOrderRef = firestore.collection(mediasOrder).doc("order");

    mediaOrderRef.get().then((doc) => {
      if (doc.exists) {
        categoryData = doc.data();
      } else categoryData = null;

      const toMediasFirestore = {
        id: media.id,
        title: media.title,
        content: media.content,
        fileName: `${media.id}_${media.fileName}`,
        fileType: media.fileType,
        videoURL: media.videoURL,
        modifiedAt: currentTime,
      };
      const categoryOrder = {
        id: "order",
        modifiedAt: currentTime,
        order:
          categoryData?.order?.length > 0
            ? !categoryData?.order.includes(media.id)
              ? [...categoryData?.order, media.id]
              : [...categoryData?.order]
            : [media.id],
      };
      batch.set(mediaOrderRef, categoryOrder, { merge: true });
      batch.set(mediaRef, toMediasFirestore, { merge: true });
      !media.file &&
        dispatch({
          type: adding,
        });
      batch
        .commit()
        .then(() => {
          if (media.file) {
            const storageRef = firebase.storage().ref();
            const uploadRef = storageRef
              .child(medias)
              .child(`${media.id}_${media.fileName}`);

            return uploadRef.put(media.file).on(
              "state_changed",

              () => {
                dispatch({
                  type: adding,
                });
              },

              (error) => {
                dispatch({ type: ERROR, error });
              },

              () => {
                uploadRef
                  .getDownloadURL()
                  .then(function (downloadURL) {
                    const skillThumbnail = {
                      fileURL: downloadURL,
                    };

                    const batch = firestore.batch();
                    batch.update(mediaRef, skillThumbnail);

                    batch
                      .commit()
                      .then(() => {
                        dispatch({ type: added });
                        dispatch({ type: clearStatus });
                      })
                      .catch((err) => {
                        dispatch({ type: ERROR, err });
                      });
                  })
                  .catch((err) => {
                    dispatch({ type: ERROR, err });
                  });
              }
            );
          } else {
            dispatch({ type: added });
            dispatch({ type: clearStatus });
          }
        })
        .catch((e) => {
          dispatch({ type: ERROR, err: e });
        });
    });
  };
};

export const handleOrderChangeOfMedia = (order) => {
  return (dispatch, not, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();
    const batch = firestore.batch();
    const currentTime = firebase.firestore.Timestamp.fromDate(today);
    const mediaOrderRef = firestore.collection(mediasOrder).doc("order");

    const toFirestore = {
      id: "order",
      modifiedAt: currentTime,
      order: [...order],
    };
    batch.set(mediaOrderRef, toFirestore, { merge: true });
    batch
      .commit()
      .then()
      .catch((e) => {});
  };
};

export const deleteMedia = (id) => {
  const deleted = "MEDIA_deleted";
  const deleting = "MEDIA_deleteING";
  const ERROR = "MEDIA_delete_ERROR";
  const clearStatus = "MEDIA_delete_CLEAR_STATUS";

  return (dispatch, not, { getFirebase, getFirestore }) => {
    dispatch({ type: deleting });

    const firestore = getFirestore();
    const firebase = getFirebase();
    const currentTime = firebase.firestore.Timestamp.fromDate(today);

    const mediaRef = firestore.collection(medias).doc(id);

    mediaRef.get().then((doc) => {
      if (doc.exists) {
        const mediaOrderRef = firestore.collection(mediasOrder).doc("order");
        const docData = doc.data();
        const fileName = docData.fileName;
        const storageRef = firebase.storage().ref();
        mediaOrderRef.get().then((doc) => {
          if (doc.exists) {
            const orderWiki = doc.data();
            let wikiArray = [...orderWiki.order];
            wikiArray = removeFromArray(wikiArray, id);
            const batch = firestore.batch();
            const wikis = {
              modifiedAt: currentTime,
              order: wikiArray,
            };
            batch.set(mediaOrderRef, wikis, { merge: true });

            batch.commit().then(() => {
              if (fileName) {
                const uploadRef = storageRef.child(medias).child(fileName);
                uploadRef.delete();
              }

              mediaRef
                .delete()
                .then(
                  () => {
                    dispatch({ type: deleted });
                    dispatch({ type: clearStatus });
                  }
                  // uploadRef.delete().then(()=>{})
                )
                .catch(() => dispatch({ type: ERROR }));
            });
          }
        });
      }
    });
  };
};
